import React from "react";
import styled from "styled-components";
import loading from "../assets/prognos_logotyp_white.png";

const LoadingImage = styled.div`
  grid-area: center;
  background-image: url(${props => props.src});
  background-repeat: no-repeat;
  background-position: center 20%;
  height: 100%;
  width: 100%;
`;

const Loader = () => {
    return <LoadingImage src={loading}/>;
};

export default Loader;
